module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0085.png.8a3b7e9c.jpg";